import { Flex, Text } from '@chakra-ui/react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Relevant = ({meeting}) => {
  const navigate = useNavigate()
  // useEffect(() => console.log('mmmm', meeting), [])

  const handleClick = () => {
    const eventId = meeting.reccuring_previous_event_event_id || meeting.meeting.previous_event_event_id
    navigate(`/transcripts-summaries/summary?eventId=${eventId}&tab=HIGH`)
  }

  return (
    <Flex
      flexDirection='column'
      border='0.5px solid rgba(28, 28, 28, 0.1)'
      boxShadow='0px 13px 5px rgba(0, 0, 0, 0.01), 0px 7px 4px rgba(0, 0, 0, 0.02), 0px 3px 3px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)'
      borderRadius='12px'
      bg='white'
      p={5}
      flex={1}
      position='relative'
    >

      <Flex alignItems='center' mb='auto'>
        <Text color='#EF8354' fontWeight='800' fontSize='12px'>
          RELEVANT
        </Text>

        <Text ml='auto' color='#1C1C1C' fontSize='14px' letterSpacing='-0.01em' lineHeight='22px' opacity='0.7'>
          {meeting.reccuring_previous_event_event_id ? meeting.recurringPreviousMeetingTimeSince: meeting.previousMeetingTimeSince}
        </Text>
      </Flex>

      <Flex mt={3} alignItems='center'>
        <Text onClick={() => handleClick()} cursor='pointer' color='brandTextBlack' fontWeight='600' lineHeight='22px' maxW='166px'>
          {meeting.reccuring_previous_event_event_id ? meeting.reccuring_previous_event_title: meeting.previous_event_title}
        </Text>
        
      </Flex>

      <Flex mt={0} alignItems='center'>
        <Text color='#1C1C1C' fontSize='14px' letterSpacing='-0.01em' lineHeight='22px' opacity='0.7'>
          {meeting.reccuring_previous_event_event_id ? meeting.recurringPreviousMeetingDuration: meeting.previousMeetingDuration}
        </Text>
      </Flex>

    </Flex>
  )
}

export default Relevant